module.exports = __webpack_public_path__ + "static/media/icicilombard.33c0e2c1.png";